export default "/fonts/RV-Harmonia-Regular.woff?e20a87a1c09e46685ae1e4868f6c6d48";